<template>
    <div>
        <div>
            <h3>Fechamento por Clientes</h3>
        </div>
        <span class="span-month">Mês de referência:</span>
        <date-picker
            v-model ="month"
            format="MMMM/YYYY"
            type="month"
            v-on:change="loadMonth"
        >
        </date-picker>
        <button v-if="!processed" class="btn btn-primary btns" @click="process" :disabled="loading">Processar</button>
        <button v-if="processed" class="btn btn-danger btns" @click="deleteProcess" :disabled="loading">Excluir</button>
        <button v-if="!tasksProcessed && processed" class="btn btn-primary btns" @click="taskProcess" :disabled="loading">Processar Atividades</button>
        <button class="btn btn-primary btns" v-on:click="csv">Baixar CSV</button>

        <div v-if="loading" >
            <i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i>
        </div>
        <div v-else class="row customer-costs">
            <div class="header-fixed">
                <div class="header fake-table">
                    <div class="name">Cliente</div>
                    <div class="user-data">Tempo gasto</div>
                    <div class="user-data">%</div>
                    <div class="user-data">Custo</div>
                    <div class="user-data">H. prop.</div>
                    <div class="user-data">H. totais</div>
                    <div class="user-data">%</div>
                    <div class="user-data">Hon. bruto</div>
                    <div class="user-data">Custo trib.</div>
                    <div class="user-data">Hon. liq.</div>
                    <div class="user-data">C. M. rat.</div>
                    <div class="user-data">C. M. total</div>
                    <div class="user-data">R. bruto</div>
                    <div class="user-data">M. bruta</div>
                    <div class="user-data">Rat. desp.</div>
                    <div class="user-data">R. liq.</div>
                    <div class="user-data">M. liq.</div>
                </div>
            </div>
            <div v-for="customer in closure" :key="customer.customer_id">
                <div class="fake-table">
                    <div class="name">{{ customer.name }}</div>
                    <div class="user-data">{{ secondsToDate(customer.time_spent) }}</div>
                    <div class="user-data">
                        {{ replaceNumber(parseFloat(customer.time_spent_percent).toFixed(2)) }}%</div>
                    <div class="user-data">{{ numberFormat(customer.cost_task) }}</div>
                    <div class="user-data">
                        {{ customer.apportionment ? 0 : secondsToDate(customer.time_spent_prop) }}</div>
                    <div class="user-data">
                        {{ customer.apportionment ? 0 : secondsToDate(customer.time_spent_total) }}</div>
                    <div class="user-data">
                        {{ customer.apportionment ? 0 :
                        replaceNumber(parseFloat(customer.time_spent_prop_total).toFixed(2)) }}%</div>
                    <div class="user-data">{{ customer.apportionment ? 0 : numberFormat(customer.fee) }}</div>
                    <div class="user-data">
                        {{ customer.apportionment ? 0 : numberFormat(customer.cost_tributary) }}</div>
                    <div class="user-data">{{ customer.apportionment ? 0 : numberFormat(customer.fee_liq) }}</div>
                    <div class="user-data">
                        {{ customer.apportionment ? 0 : numberFormat(customer.cost_task_appor) }}</div>
                    <div class="user-data">
                        {{ customer.apportionment ? 0 : numberFormat(customer.cost_task_total) }}</div>
                    <div class="user-data">{{ customer.apportionment ? 0 : numberFormat(customer.raw_score) }}</div>
                    <div class="user-data">
                        {{ customer.apportionment ? 0 :
                        replaceNumber(parseFloat(customer.gross_margin).toFixed(2)) }}%</div>
                    <div class="user-data">{{ customer.apportionment ? 0 : numberFormat(customer.expense_prop) }}</div>
                    <div class="user-data">{{ customer.apportionment ? 0 : numberFormat(customer.net_income) }}</div>
                    <div class="user-data">
                        {{ customer.apportionment ? 0 :
                        replaceNumber(parseFloat(customer.net_margin).toFixed(2)) }}%</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
    name: 'CustomerCostClosure',
    components: {
        DatePicker
    },
    mounted () {
        this.loadMonth()
        this.init()
    },
    data () {
        return {
            month: new Date (),
            processed: false,
            tasksProcessed: false,
            closure: '',
            loading: true,
            users: '',
            loadingUser: false,
            loadingClosure: false
        }
    },
    computed: {
        ...mapGetters({
            token: 'auth/token',
        }),
    },
    methods: {
        init () {
            this.processed = false
            this.loading = true
        },

        numberFormat (number) {
          return new Intl.NumberFormat('pt-BR',{style: 'currency', currency: 'BRL'}).format(number)
        },

        replaceNumber (number) {
            return number.toString().replace('.', ',')
        },

        secondsToDate (seconds) {
            if (isNaN(seconds)) {
                return '00:00:00'
            }
            let hours = Math.floor(seconds / 3600)
            seconds %= 3600
            let minutes = Math.floor(seconds / 60)
            seconds = seconds % 60

            return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
        },

        loadMonth () {
            this.init()
            this.tasksProcessed = false

            axios.get('/api/customers/cost/closure?year='
                + this.month.getFullYear() + '&month=' + (this.month.getMonth() + 1))
                .then((response) => {
                    this.closure = response.data.data
                    this.loading = false
                    if (this.closure.length) {
                        this.processed = true
                    }
                })
            let startDate = new Date(this.month.getFullYear(), this.month.getMonth(), 1)
            let endDate = new Date(this.month.getFullYear(), this.month.getMonth(), 28)
            axios
                .get('/api/tasks_made_verification?startDate='
                    + this.formatDate(startDate) + '&endDate=' + this.formatDate(endDate))
                .then((response) => {
                    this.tasksMade = response.data.data
                    if (this.tasksMade.length) {
                        this.tasksProcessed = true
                    }
                })
        },

        formatDate (date) {
            return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2));
        },

        process () {
            this.loading = true
            axios.post('/api/customers/cost/closure', {
                year: this.month.getFullYear(),
                month: this.month.getMonth() + 1
            })
                .then(() => {
                    this.loadMonth()
                })
                .catch((response) => {
                    let err = response.response.data.errors
                    let message = ''
                    for (let i in err) {
                        message = err[i] + '<br />' + message
                    }
                    this.$swal({
                        title: 'Ops...',
                        text: message,
                        icon: 'error',
                        html: message
                    })
                })
        },

        csv () {
            const year = this.month.getFullYear()
            const month = this.month.getMonth() + 1
            window.open(process.env.VUE_APP_URL + '/api/customers/cost/closure/csv?year='+year+'&month='+month+'&api_token='+ this.token)
        },

        deleteProcess () {
            this.$swal({
                title: 'Atenção',
                text: 'Realmente deseja excluir o processamento',
                icon: 'warning',
                showCancelButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete('/api/customers/cost/closure?year='
                        + this.month.getFullYear() + '&month=' + (this.month.getMonth() + 1))
                        .then(() => {
                            this.loadMonth()
                        })
                }
            })
        },

        taskProcess () {
            this.loading = true
            axios.post('/api/tasks_made_verification?year='
                + this.month.getFullYear() + '&month=' + (this.month.getMonth() + 1))
                .then(() => {
                    this.tasksProcessed = true
                    this.$swal({
                        title: 'Sucesso',
                        text: 'Atividades processadas',
                        icon: 'success'
                    })
                    this.loading = false
                })
        }
    }
}
</script>

<style lang="sass">
    .btns
        margin-left: 20px

    .customer-costs
        margin-top: 20px
        width: 1840px
        font-size: 12px

    .fake-table
        border: 1px solid
        display: inline-block

        .name
            display: inline-block
            width: 200px
            max-width: 300px
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
            padding: 8px
            margin-bottom: -8px

        .user-data
            overflow: hidden
            display: inline-block
            width: 100px
            border-left: 1px solid
            padding: 8px
            margin-bottom: -8px

    .header-fixed
        background: white
        position: -webkit-sticky
        position: sticky
        top: 55px
        padding-top: 5px

    .header-total
        background: #bdbdbd7a

</style>
